import React, { useEffect, useState } from 'react'
import MEModal from '../../components/MEModal'
import { Form } from 'react-bootstrap'
import { Button } from '@CommonComponents/buttons'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { saveNewSectionName } from '../actions'

export const editSectionNameItem = {
  id: 'edit-section-name',
  label: 'Edit Section Name',
  icon: 'fa-light fa-pencil-alt',
}

export const EditSectionNameModal = ({ sectionName, section, show, close }) => {
  const [currentState, dispatch] = useStateValue()
  const [editedSectionName, setEditedSectionName] = useState(sectionName)

  useEffect(() => {
    setEditedSectionName(sectionName)
  }, [sectionName])

  const handleEditSectionName = (e) => {
    setEditedSectionName(e.target.value)
  }

  const submitEditSectionName = async () => {
    let data = { ...currentState.filters }
    data.section_name = editedSectionName
    data.section_id = section
    data.pageNum = currentState.currentCourseMemPage
    data.archivedPageNum = currentState.currentArchivePage
    close()
    let response = await saveNewSectionName(data, dispatch)
    if (response.status === 200) {
      toast.success("Successfully updated the section name.")
    } else {
      toast.error(`There was an error trying to save your new section name: ${response.data.error}`)
    }
  }

  return (
    <MEModal show={show} close={close} title="Edit Section Name">
      <form onSubmit={e => e.preventDefault()}>
        <p>
          Enter a new name for the section below. Signup links and other
          information will not be affected.
        </p>
        <Form.Group>
          <Form.Label>Section Name</Form.Label>
          <Form.Control
            type="text"
            onChange={handleEditSectionName}
            value={editedSectionName}
          />
        </Form.Group>
        <Button
          className="me-btn me-btn-primary"
          type="button"
          onClick={submitEditSectionName}
        >
          Save section name
        </Button>
      </form>
    </MEModal>
  )
}
